import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Redirect,
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import { AuthService } from "../services";
import { store } from "../store";
import { SNACKBAR_ACTION } from "../store/root/root.actions";
import { selectSnackbar } from "../store/root/root.selector";

import AuthPage from "./auth";
import Root from "./index";

const PrivateRoute = ({ component: Component, ...rest }: any) => {
  const render = (props: any) => {
    if (!AuthService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }
    return <Component {...props} />;
  };
  return <Route {...rest} render={render} />;
};

const RoutingComponent: React.FC = () => {
  const snackbar = useSelector(selectSnackbar);
  const notification = useSnackbar();

  useEffect(() => {
    if (snackbar.open) {
      notification.enqueueSnackbar(snackbar.message, {
        variant: snackbar.type,
        autoHideDuration: 1000,
        onClose: () => {
          store.dispatch(
            SNACKBAR_ACTION({ message: "", open: false, type: "default" })
          );
        },
      });
    }
  }, [snackbar,notification]);

  return (
    <Router>
      <Switch>
        <Route exact path="/login" component={AuthPage} />
        <PrivateRoute path="/" component={Root} />
      </Switch>
    </Router>
  );
};

export default RoutingComponent;
